<template>
  <transition name="slide-fade">

  <div class="login">
      <div class="login-bg"></div>

      <main class="main">

        <img src="~@/assets/images/logo-full-mono-light.png" alt="">
        <h1>Reset password</h1>

        <div class="box row" v-if="token">

          <transition name="slide-fade">
            <div v-if="localError" class="alert alert-danger col" role="alert">
              {{localError}}
            </div>
          </transition>

          <transition name="slide-fade">
            <div v-if="serverError" class="alert alert-danger col" role="alert">
              {{serverError}}
            </div>
          </transition>

          <div class="form-group has-feedback has-feedback-left col-12" :class="{ 'has-danger' : errors.has('password') }">
            <label class="form-control-label hidden" for="password">Password</label>
            <div class="input-icon">
              <span class="oi oi-lock-locked"></span>
            </div>
            <b-form-input
                  type="password"
                  v-model="password"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  :is-invalid="!validPassword"
                  :class="{ 'is-invalid' : !validPassword && this.password}"
                  placeholder="Password"></b-form-input>
                  <div class="row pt-2">
                  <div class="col-sm-5 col-md-4">Password Strength</div>
                  <div class="col-sm-7 col-md-8"><password v-model="password" :strength-meter-only="true"/></div>
                </div>

                <div class="invalid-feedback">
                    <span v-if="!validPassword && this.password">{{invalidPasswordMessage}}</span>
                </div>
            <div class="invalid-feedback" v-show="errors.has('password')">{{ errors.first('password') }}</div>
          </div>

          <div class="form-group has-feedback has-feedback-left col-12" :class="{ 'has-danger' : errors.has('password') }">
            <label class="form-control-label hidden" for="passwordConfirm">Password</label>
            <div class="input-icon">
              <span class="oi oi-lock-locked"></span>
            </div>
            <input type="password" :class="{ 'is-invalid' : errors.has('passwordConfirm')  && fields.passwordConfirm.touched  }" class="form-control" data-vv-as="password" v-validate="'required|min:8'" v-model="passwordConfirm" name="passwordConfirm" id="passwordConfirm" placeholder="Confirm">
            <div class="invalid-feedback" v-show="errors.has('passwordConfirm')">{{ errors.first('passwordConfirm') }}</div>
            <p class='mt-4'><b>Password requirement: </b>Minimum 8 chacters long including at least one number and one symbol.</p>
          </div>

          <b-button type="submit" variant="primary" v-on:click="postPasswordReset" class="loading">Reset</b-button>

        </div>

        <div class="box row" v-if="!token">
          <div class="alert alert-danger col-12" role="alert">
            Could not parse token
          </div>
        </div>

      </main>
  </div>
  </transition>
</template>

<script>
import Password from 'vue-password-strength-meter'

export default {
  name: 'ResetPassword',
  components: {Password},
  data () {
    return {
      password: '',
      passwordConfirm: '',
      localError: null
    }
  },
  computed: {
    invalidPasswordMessage: function () {
      if (!this.isPasswordLengthSatisfied) {
        return 'Password needs to be at least 8 characters long.'
      }
      if (!this.doesPasswordContainsSpecialCharacter) {
        return 'Password needs to have at least one special character'
      }
      if (!this.doesPasswordContainsAtleastOneNumber) {
        return 'Password needs to have at least one number character'
      }
      if (this.password !== this.passwordConfirm) {
        return 'Password and confirm password does not match.'
      }
    },
    validPassword: function () {
      return !this.errors.has('password') && this.password === this.passwordConfirm && this.isPasswordLengthSatisfied && this.doesPasswordContainsSpecialCharacter && this.doesPasswordContainsAtleastOneNumber
    },
    isPasswordLengthSatisfied: function () {
      return this.password && this.password.length >= 8
    },
    doesPasswordContainsSpecialCharacter: function () {
      // eslint-disable-next-line no-useless-escape
      return /[!@#\$%\^\&*\)\(+=._-]/.test(this.password)
    },
    doesPasswordContainsAtleastOneNumber: function () {
      // eslint-disable-next-line no-useless-escape
      return /\d/.test(this.password)
    },
    token: function () {
      return Object.keys(this.$route.query)[0]
    },
    serverError: function () {
      return (this.$store.state.POST_PASSWORD_RESET_FAILURE) ? 'Could not reset password' : null
    }
  },
  methods: {

    postPasswordReset () {
      if (this.errors.any()) {
        return
      }

      this.localError = null
      if (this.validPassword) {
        this.$store.dispatch('postPasswordReset', {
          token: this.token,
          password: this.password
        }).then(success => {
          this.$router.push('/login')
        }).catch(error => {
          this.error = error.response.data.message
        })
      } else {
        this.localError = this.invalidPasswordMessage
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  body{
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/templates/ResetPassword.vue